import * as React from 'react'
import { Text } from '../Text'
import { ModalBox } from '../ModalBox'

interface Props {
  text: string
  title?: string
  buttonLabel: string
  onClick: () => void
}

export const Notification: React.SFC<Props> = ({ text, title, buttonLabel, onClick }) => (
  // tslint:disable-next-line
  <ModalBox onAcceptClick={onClick} title={title} simple buttonLabel={buttonLabel}>
    <Text>{text}</Text>
  </ModalBox>
)



// WEBPACK FOOTER //
// ./src/views/components/Notification/Notification.tsx